import { useEffect, useState } from "react";

import { type KeystoneInspection } from "data/keystone-api-mapping";
import { useInspectionsList } from "data/ss-data-hooks";
import { useFlags } from "utils";

export const useInspectionsData = () => {
  const { inspectionsProofUpload } = useFlags();
  const {
    error,
    isLoading,
    data: inspectionsData,
    mutate,
  } = useInspectionsList(!!inspectionsProofUpload);
  const [latestInspection, setLatestInspection] =
    useState<KeystoneInspection>();

  // inspectionWriteOutDueDate should be non-null only for policies that are pending
  // cancellation - use it for the inspection due date if it exists.
  const inspectionDueDate =
    latestInspection?.inspectionWriteOutDueDate ??
    inspectionsData?.inspectionDeadline;

  // Use latest inspection:
  useEffect(() => {
    if (!inspectionsData) {
      return;
    }
    const inspections = inspectionsData.inspections ?? [];
    if (inspections.length === 0) {
      setLatestInspection(undefined);
      return;
    }
    const latest = [...inspections].sort(
      (a, b) =>
        new Date(b.createdTimestamp).getTime() -
        new Date(a.createdTimestamp).getTime(),
    )[0];

    if (latest) {
      setLatestInspection(latest);
    }
  }, [inspectionsData, inspectionsData?.inspections]);

  return {
    error,
    isLoading,
    latestInspection,
    inspectionDueDate,
    refetch: mutate,
  };
};
